import type { ShouldRevalidateFunction } from "@remix-run/react";

/** loader 재검증을 건너뛸 mutation (자동저장·경량 토글 등) */
export function shouldSkipLoaderRevalidate(
  formData?: FormData | null
): boolean {
  if (!formData) return false;
  if (formData.get("_ajax") === "true") return true;
  if (formData.get("_skipRevalidate") === "true") return true;
  // 평가자 담당 분야 토글: action 응답 + 로컬 state로 충분
  if (formData.get("intent") === "setEvaluatorGroups") return true;
  // 채점 화면 제출 자료 지연 로드: fetcher 응답만 사용
  if (formData.get("intent") === "loadParticipantFiles") return true;
  return false;
}

/**
 * 채점 화면에서 불필요한 loader 재실행을 건너뜁니다.
 * - 자동 저장(_ajax=true)
 * - participantId 쿼리만 바뀐 경우 (대상자 전환은 클라이언트 state로 처리)
 */
export const skipRevalidateOnAutoSave: ShouldRevalidateFunction = ({
  formData,
  currentUrl,
  nextUrl,
  defaultShouldRevalidate,
}) => {
  if (shouldSkipLoaderRevalidate(formData)) {
    return false;
  }

  if (currentUrl.pathname === nextUrl.pathname) {
    const currentParticipantId = currentUrl.searchParams.get("participantId");
    const nextParticipantId = nextUrl.searchParams.get("participantId");

    if (currentParticipantId !== nextParticipantId) {
      const currentParams = new URLSearchParams(currentUrl.search);
      const nextParams = new URLSearchParams(nextUrl.search);
      currentParams.delete("participantId");
      nextParams.delete("participantId");

      if (currentParams.toString() === nextParams.toString()) {
        return false;
      }
    }
  }

  return defaultShouldRevalidate;
};

/**
 * root loader: 탭/메뉴 Link 이동마다 users 재조회하지 않음.
 * - GET 네비게이션 → 캐시된 root 데이터 유지
 * - POST/PUT/DELETE 등 mutation → 재실행 (로그인·로그아웃·프로필 변경)
 * - _ajax / 경량 토글 → 스킵
 */
export const skipRootRevalidateOnClientNav: ShouldRevalidateFunction = ({
  formMethod,
  formData,
}) => {
  if (shouldSkipLoaderRevalidate(formData)) {
    return false;
  }

  if (formMethod && formMethod.toUpperCase() !== "GET") {
    return true;
  }

  return false;
};
